module.exports = __webpack_public_path__ + "img/refresh-cw.286819b2.svg";